<div class="file-input-container">
    <label *ngIf="label" for="{{ id }}" [ngClass]="{ error: errorState() }">{{ label }}{{ required ? '*' : '' }}</label>
    <div class="file-input" [ngClass]="{ focused: focused(), error: errorState() }">
        <span class="file-name" [ngClass]="{ error: errorState() }" (click)="fileInput.click()">
            {{ file ? file.name : '' }}
        </span>
        <input class="hidden-input" #fileInput type="file" />

        <button
            mat-stroked-button
            class="riege-button file-button"
            type="button"
            (focusin)="onFocusIn($event)"
            (focusout)="onFocusOut($event)"
            (click)="fileInput.click()"
            i18n="@@button-label-file-input">
            Browse files
        </button>
    </div>
    <!-- todo: TWEBER nochmal gegenchecken nach Urlaub (doppelte hint Abfrage) -->
    <mat-hint ngClass="file-input__helper-text" *ngIf="hint"> {{ hint }} </mat-hint>

    <mat-hint ngClass="file-input__helper-text" *ngIf="allowedTypes.length && validType()">
        <span>{{ allowedTypes.length > 1 ? typeFew : typeOne }}</span> {{ allowedTypes.join(', ').toUpperCase() }}.
    </mat-hint>

    <mat-error ngClass="file-input__helper-text error" *ngIf="notGiven()">
        <span i18n="@@error-file-required">Select a file.</span>
    </mat-error>

    <mat-error ngClass="file-input__helper-text error" *ngIf="!validType()">
        <span i18n="@@error-file-notsupported">File type not supported.</span>
    </mat-error>
</div>
